/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{convertBoundingBoxToBox as o,transformBoxPoints as t}from"../geometry/conversion.js";import{translateAxis as e}from"../geometry/delta-apply.js";function r(e,r){return o(t(e.getBoundingClientRect(),r))}function n(o,t,n){const f=r(o,n),{scroll:i}=t;return i&&(e(f.x,i.offset.x),e(f.y,i.offset.y)),f}export{n as measurePageBox,r as measureViewportBox};
//# sourceMappingURL=measure.js.map
